import { useLayoutEffect, useRef, useState } from 'react'

type EscapeHandler = (event: KeyboardEvent) => void

interface EscapeHandlerEntry {
  handlerRef: { current: EscapeHandler }
  order: number
}

const escapeHandlerStack: EscapeHandlerEntry[] = []
let nextOrder = 0

const handleDocumentKeyDown = (event: KeyboardEvent): void => {
  if (event.key !== 'Escape' || event.defaultPrevented) return
  escapeHandlerStack[escapeHandlerStack.length - 1].handlerRef.current(event)
}

export const useEscapeKey = (onEscape: EscapeHandler): void => {
  const handlerRef = useRef(onEscape)
  const [order] = useState(() => nextOrder++)

  useLayoutEffect(() => {
    handlerRef.current = onEscape
  }, [onEscape])

  useLayoutEffect(() => {
    const entry = { handlerRef, order }
    const insertAt = escapeHandlerStack.findIndex(other => other.order > order)

    if (escapeHandlerStack.length === 0) document.addEventListener('keydown', handleDocumentKeyDown)
    escapeHandlerStack.splice(insertAt === -1 ? escapeHandlerStack.length : insertAt, 0, entry)

    return () => {
      escapeHandlerStack.splice(escapeHandlerStack.indexOf(entry), 1)
      if (escapeHandlerStack.length === 0) document.removeEventListener('keydown', handleDocumentKeyDown)
    }
  }, [order])
}
